<mat-form-field [formGroup]="group" [appearance]="appearance">
  <mat-label>{{field?.localeText?.name}}</mat-label>
  <input matInput
         [appAllowCharacters]="field.restrictAllowCharacters !== undefined"
         [disallowCharacters]="field.restrictAllowCharacters?.disallowedCharacters"
         [allowCharacters]="field.restrictAllowCharacters?.allowedCharacters"
         [formControlName]="field.fieldKey" [name]="field.fieldKey" [autocomplete]="field.autocomplete"
         [readonly]="field?.readOnly" [placeholder]="field.localeText?.placeholder?field.localeText?.placeholder:field.localeText?.name" [type]="type"
         [required]="field.required" (input)="processLowercase($event)">
  <mat-hint *ngIf="field?.localeText.hint">{{field?.localeText.hint}}</mat-hint>
  <ng-container *ngFor="let validation of field.validation;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.fieldKey).hasError(validation.name)" role="alert">
      {{validation.message}}
    </mat-error>
  </ng-container>
</mat-form-field>
